// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class GetBestEnrollmentResponse {
    static getAttributeTypeMap() {
        return GetBestEnrollmentResponse.attributeTypeMap;
    }
}
GetBestEnrollmentResponse.discriminator = undefined;
GetBestEnrollmentResponse.additionalProperties = false;
GetBestEnrollmentResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "EnrollmentModel"
    },
];
//# sourceMappingURL=getBestEnrollmentResponse.js.map